import { ref, type Ref } from 'vue'

import { useLocalStorage } from '@/shared/composables'
import { isPlayerNameMode, isViewMode } from '../../lib/boardInvariants'
import { PlayerNameMode as PlayerNameModeValue, ViewMode as ViewModeValue } from '../../types'
import type { Player, PlayerGroup, PlayerNameMode, Room, ViewMode } from '../../types'

export interface BoardStateApi {
  readonly players: Ref<ReadonlyArray<Player>>
  readonly guildPlayerDiscordIds: Ref<ReadonlyArray<string> | null>
  readonly groups: Ref<ReadonlyArray<PlayerGroup>>
  readonly rooms: Ref<ReadonlyArray<Room>>
  readonly viewMode: Ref<ViewMode>
  readonly playerNameMode: Ref<PlayerNameMode>
  readonly persistViewMode: (mode: ViewMode) => void
  readonly persistPlayerNameMode: (mode: PlayerNameMode) => void
}

export function useBoardState(): BoardStateApi {
  const players = ref<ReadonlyArray<Player>>([])
  const guildPlayerDiscordIds = ref<ReadonlyArray<string> | null>(null)
  const groups = ref<ReadonlyArray<PlayerGroup>>([])
  const rooms = ref<ReadonlyArray<Room>>([])
  const viewModeRef = useLocalStorage<ViewMode>(
    'wwm-gvg-view-mode-v1',
    ViewModeValue.Detail,
    { validate: isViewMode },
  )
  const viewMode = viewModeRef as Ref<ViewMode>
  const playerNameModeRef = useLocalStorage<PlayerNameMode>(
    'wwm-gvg-player-name-mode-v1',
    PlayerNameModeValue.GuildNickname,
    { validate: isPlayerNameMode },
  )
  const playerNameMode = playerNameModeRef as Ref<PlayerNameMode>

  const persistViewMode = (mode: ViewMode): void => {
    viewMode.value = mode
  }

  const persistPlayerNameMode = (mode: PlayerNameMode): void => {
    playerNameMode.value = mode
  }

  return {
    players,
    guildPlayerDiscordIds,
    groups,
    rooms,
    viewMode,
    playerNameMode,
    persistViewMode,
    persistPlayerNameMode,
  }
}
